// services/report.service.ts
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { BaseApiService } from './base-api.service';

@Injectable({
  providedIn: 'root'
})
export class ReportService extends BaseApiService {

  getClosedDate(reportName: string): Observable<string> {
    const endpoint = `/reports/closedDate/${reportName}`;
    const url = `${this.getBaseUrl()}${endpoint}`;
    
    return this.getHttpClient().get(url, {
      responseType: 'text',
      headers: this.getAuthHeaders(),
    }).pipe(
      map((response: string) => {
        // Remove aspas se a resposta vier como JSON string (com aspas)
        if (response && response.startsWith('"') && response.endsWith('"')) {
          try {
            return JSON.parse(response);
          } catch {
            return response;
          }
        }
        return response || '';
      }),
      catchError((error) => {
        console.error('Erro ao buscar closed date:', error);
        // Retorna string vazia em caso de erro
        return of('');
      })
    );
  }
}
